import { Divider, Grid, Typography } from "@material-ui/core";
import React from "react";

const DashboardSectionHeader = ({ heading = "" }) => {
  return (
    <Grid container direction="column" className="gap-y-16 mb-16">
      <Grid
        item
        container
        direction="row"
        justifyContent="flex-start"
        alignItems="center"
        className="gap-x-8"
      >
        <Typography variant="h5" className="text-capitalize ">
          {heading}
        </Typography>
      </Grid>
      <Divider />
    </Grid>
  );
};

export default DashboardSectionHeader;
